export const blueBoxThreeColData = [
  {
    heading: 'Simplicity',
    text: 'We believe that financing a car should be simple and accessible for everyone. We remove the hassle and jargon so all you need to worry about is finding a car you love.'
  },
  {
    heading: 'Being on your side',
    text: 'We know car buying can be a little complicated, especially if it’s the first time you’ve done it. We offer help and support throughout the car buying process and we’ll check the background of every car and dealership without charging a penny.'
  },
  {
    heading: 'Transparency',
    text: 'We never add hidden costs, we’re completely transparent with all figures and we always make sure you understand everything. This means you can make an informed choice with no nasty surprises.'
  }
]

export const threeColData = [
  {
    imageAlt: 'Founded in 2006',
    imageSrc: 'https://cdn.zuto.cloud/assets/images/about-zuto/mobile/founded.png',
    imgWidth: 175,
    imgHeight: 120,
    heading: 'Founded in 2006',
    text: 'Car Loan 4U was born with a plan to change the way the people bought cars forever. Our name has changed since then, but the mission continues. We&apos;ve got 18 years experience in car finance and buying support. Thousands of customers have trusted us, and we&apos;re proud to be rated ‘Excellent’ on Trustpilot.'
  },
  {
    imageAlt: 'Doing things differently',
    imageSrc: 'https://cdn.zuto.cloud/assets/images/about-zuto/mobile/invest.png',
    imgWidth: 155,
    imgHeight: 120,
    heading: 'Doing things differently',
    text: 'We pride ourselves on leading the way in car finance and helping to transform the industry. We like to do things a little bit differently, using our technology to help make car finance accessible for as many customers as possible. We’re proud to have helped over 450,000 customers find the right car finance package.'
  },
  {
    imageAlt: 'Business for good',
    imageSrc: 'https://cdn.zuto.cloud/assets/images/about-zuto/mobile/best-company.png',
    imgWidth: 162,
    imgHeight: 120,
    heading: 'Business for good',
    text: 'We want to help drive positive change in our industry and beyond. We’re a proud B Corp, we’re in the top 25 Best Large Companies to work for, part of the Automotive 30% Club and a dedicated supporter of Forever Manchester. We consider not just our customers and employees but our local community and the planet too.'
  }
]
